module.exports = __webpack_public_path__ + "static/media/bg11.c170f813.jpeg";